import { QuestionBase } from './question-base';

export class TextboxQuestion extends QuestionBase<string> {
  constructor(options: any = {}) {
    super(options);
    this.controlType = 'textbox';
    this.type = options['type'] || '';
  }
}
